/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.CategoryPredict.CategoryCreateTaskRequest', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryExportChunk', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryOperationResponse', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryPreviewRow', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryQuotaRequest', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryQuotaResponse', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskInfo', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskPageRequest', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskPageResponse', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskRequest', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskResponse', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskRow', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskRowsRequest', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryTaskRowsResponse', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryUploadRequest', null, global);
goog.exportSymbol('proto.CategoryPredict.CategoryUploadResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryQuotaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryQuotaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryQuotaRequest.displayName = 'proto.CategoryPredict.CategoryQuotaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryQuotaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryQuotaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryQuotaResponse.displayName = 'proto.CategoryPredict.CategoryQuotaResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryUploadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryUploadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryUploadRequest.displayName = 'proto.CategoryPredict.CategoryUploadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryPreviewRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryPreviewRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryPreviewRow.displayName = 'proto.CategoryPredict.CategoryPreviewRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryUploadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.CategoryPredict.CategoryUploadResponse.repeatedFields_, null);
};
goog.inherits(proto.CategoryPredict.CategoryUploadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryUploadResponse.displayName = 'proto.CategoryPredict.CategoryUploadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryCreateTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryCreateTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryCreateTaskRequest.displayName = 'proto.CategoryPredict.CategoryCreateTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskRequest.displayName = 'proto.CategoryPredict.CategoryTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskPageRequest.displayName = 'proto.CategoryPredict.CategoryTaskPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.CategoryPredict.CategoryTaskInfo.repeatedFields_, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskInfo.displayName = 'proto.CategoryPredict.CategoryTaskInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskResponse.displayName = 'proto.CategoryPredict.CategoryTaskResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskPageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.CategoryPredict.CategoryTaskPageResponse.repeatedFields_, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskPageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskPageResponse.displayName = 'proto.CategoryPredict.CategoryTaskPageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskRowsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskRowsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskRowsRequest.displayName = 'proto.CategoryPredict.CategoryTaskRowsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskRow.displayName = 'proto.CategoryPredict.CategoryTaskRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryTaskRowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.CategoryPredict.CategoryTaskRowsResponse.repeatedFields_, null);
};
goog.inherits(proto.CategoryPredict.CategoryTaskRowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryTaskRowsResponse.displayName = 'proto.CategoryPredict.CategoryTaskRowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryOperationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryOperationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryOperationResponse.displayName = 'proto.CategoryPredict.CategoryOperationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CategoryPredict.CategoryExportChunk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CategoryPredict.CategoryExportChunk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CategoryPredict.CategoryExportChunk.displayName = 'proto.CategoryPredict.CategoryExportChunk';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryQuotaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryQuotaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryQuotaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryQuotaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryQuotaRequest}
 */
proto.CategoryPredict.CategoryQuotaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryQuotaRequest;
  return proto.CategoryPredict.CategoryQuotaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryQuotaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryQuotaRequest}
 */
proto.CategoryPredict.CategoryQuotaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryQuotaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryQuotaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryQuotaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryQuotaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryQuotaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryQuotaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryQuotaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tier: jspb.Message.getFieldWithDefault(msg, 3, ""),
    limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
    used: jspb.Message.getFieldWithDefault(msg, 5, 0),
    reserved: jspb.Message.getFieldWithDefault(msg, 6, 0),
    remaining: jspb.Message.getFieldWithDefault(msg, 7, 0),
    unlimited: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryQuotaResponse}
 */
proto.CategoryPredict.CategoryQuotaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryQuotaResponse;
  return proto.CategoryPredict.CategoryQuotaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryQuotaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryQuotaResponse}
 */
proto.CategoryPredict.CategoryQuotaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTier(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsed(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReserved(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemaining(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimited(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryQuotaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryQuotaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryQuotaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTier();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUsed();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getReserved();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRemaining();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUnlimited();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional bool status = 1;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tier = 3;
 * @return {string}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getTier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setTier = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setLimit = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 used = 5;
 * @return {number}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setUsed = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 reserved = 6;
 * @return {number}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getReserved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setReserved = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 remaining = 7;
 * @return {number}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setRemaining = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool unlimited = 8;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryQuotaResponse.prototype.getUnlimited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryQuotaResponse.prototype.setUnlimited = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryUploadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryUploadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryUploadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    file: msg.getFile_asB64(),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryUploadRequest}
 */
proto.CategoryPredict.CategoryUploadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryUploadRequest;
  return proto.CategoryPredict.CategoryUploadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryUploadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryUploadRequest}
 */
proto.CategoryPredict.CategoryUploadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryUploadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryUploadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryUploadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional bytes file = 1;
 * @return {!(string|Uint8Array)}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.getFile = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes file = 1;
 * This is a type-conversion wrapper around `getFile()`
 * @return {string}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.getFile_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFile()));
};


/**
 * optional bytes file = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFile()`
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.getFile_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFile()));
};


/** @param {!(string|Uint8Array)} value */
proto.CategoryPredict.CategoryUploadRequest.prototype.setFile = function(value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryUploadRequest.prototype.setFileName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 file_size = 3;
 * @return {number}
 */
proto.CategoryPredict.CategoryUploadRequest.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryUploadRequest.prototype.setFileSize = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryPreviewRow.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryPreviewRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryPreviewRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryPreviewRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    rowNo: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dataJson: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryPreviewRow}
 */
proto.CategoryPredict.CategoryPreviewRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryPreviewRow;
  return proto.CategoryPredict.CategoryPreviewRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryPreviewRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryPreviewRow}
 */
proto.CategoryPredict.CategoryPreviewRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRowNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryPreviewRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryPreviewRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryPreviewRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryPreviewRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowNo();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDataJson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 row_no = 1;
 * @return {number}
 */
proto.CategoryPredict.CategoryPreviewRow.prototype.getRowNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryPreviewRow.prototype.setRowNo = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string data_json = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryPreviewRow.prototype.getDataJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryPreviewRow.prototype.setDataJson = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.CategoryPredict.CategoryUploadResponse.repeatedFields_ = [6,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryUploadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryUploadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryUploadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    uploadId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fileSize: jspb.Message.getFieldWithDefault(msg, 5, 0),
    columnsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    rowCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    previewRowsList: jspb.Message.toObjectList(msg.getPreviewRowsList(),
    proto.CategoryPredict.CategoryPreviewRow.toObject, includeInstance),
    expireTime: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryUploadResponse}
 */
proto.CategoryPredict.CategoryUploadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryUploadResponse;
  return proto.CategoryPredict.CategoryUploadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryUploadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryUploadResponse}
 */
proto.CategoryPredict.CategoryUploadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileSize(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumns(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRowCount(value);
      break;
    case 8:
      var value = new proto.CategoryPredict.CategoryPreviewRow;
      reader.readMessage(value,proto.CategoryPredict.CategoryPreviewRow.deserializeBinaryFromReader);
      msg.addPreviewRows(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpireTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryUploadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryUploadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryUploadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUploadId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getColumnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getRowCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPreviewRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.CategoryPredict.CategoryPreviewRow.serializeBinaryToWriter
    );
  }
  f = message.getExpireTime();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional bool status = 1;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string upload_id = 3;
 * @return {string}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getUploadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setUploadId = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_name = 4;
 * @return {string}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setFileName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 file_size = 5;
 * @return {number}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setFileSize = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated string columns = 6;
 * @return {!Array<string>}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getColumnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setColumnsList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.addColumns = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.clearColumnsList = function() {
  this.setColumnsList([]);
};


/**
 * optional int32 row_count = 7;
 * @return {number}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getRowCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setRowCount = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated CategoryPreviewRow preview_rows = 8;
 * @return {!Array<!proto.CategoryPredict.CategoryPreviewRow>}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getPreviewRowsList = function() {
  return /** @type{!Array<!proto.CategoryPredict.CategoryPreviewRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.CategoryPredict.CategoryPreviewRow, 8));
};


/** @param {!Array<!proto.CategoryPredict.CategoryPreviewRow>} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setPreviewRowsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.CategoryPredict.CategoryPreviewRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.CategoryPredict.CategoryPreviewRow}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.addPreviewRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.CategoryPredict.CategoryPreviewRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.clearPreviewRowsList = function() {
  this.setPreviewRowsList([]);
};


/**
 * optional string expire_time = 9;
 * @return {string}
 */
proto.CategoryPredict.CategoryUploadResponse.prototype.getExpireTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryUploadResponse.prototype.setExpireTime = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryCreateTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryCreateTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryCreateTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    uploadId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetColumn: jspb.Message.getFieldWithDefault(msg, 2, ""),
    topCategoryCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maxLevel: jspb.Message.getFieldWithDefault(msg, 4, 0),
    idempotencyKey: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryCreateTaskRequest}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryCreateTaskRequest;
  return proto.CategoryPredict.CategoryCreateTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryCreateTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryCreateTaskRequest}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetColumn(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTopCategoryCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxLevel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryCreateTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryCreateTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryCreateTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUploadId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetColumn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTopCategoryCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMaxLevel();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string upload_id = 1;
 * @return {string}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.getUploadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.setUploadId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_column = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.getTargetColumn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.setTargetColumn = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 top_category_count = 3;
 * @return {number}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.getTopCategoryCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.setTopCategoryCount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 max_level = 4;
 * @return {number}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.getMaxLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.setMaxLevel = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string idempotency_key = 5;
 * @return {string}
 */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryCreateTaskRequest.prototype.setIdempotencyKey = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskRequest}
 */
proto.CategoryPredict.CategoryTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskRequest;
  return proto.CategoryPredict.CategoryTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskRequest}
 */
proto.CategoryPredict.CategoryTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRequest.prototype.setTaskId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    current: jspb.Message.getFieldWithDefault(msg, 1, 0),
    size: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskPageRequest}
 */
proto.CategoryPredict.CategoryTaskPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskPageRequest;
  return proto.CategoryPredict.CategoryTaskPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskPageRequest}
 */
proto.CategoryPredict.CategoryTaskPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 current = 1;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskPageRequest.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskPageRequest.prototype.setCurrent = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 size = 2;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskPageRequest.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskPageRequest.prototype.setSize = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.CategoryPredict.CategoryTaskInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    targetColumn: jspb.Message.getFieldWithDefault(msg, 4, ""),
    columnsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    topCategoryCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    maxLevel: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, ""),
    totalRows: jspb.Message.getFieldWithDefault(msg, 9, 0),
    processedRows: jspb.Message.getFieldWithDefault(msg, 10, 0),
    successRows: jspb.Message.getFieldWithDefault(msg, 11, 0),
    failedRows: jspb.Message.getFieldWithDefault(msg, 12, 0),
    progress: jspb.Message.getFieldWithDefault(msg, 13, 0),
    progressMessage: jspb.Message.getFieldWithDefault(msg, 14, ""),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 15, ""),
    tier: jspb.Message.getFieldWithDefault(msg, 16, ""),
    quotaLimit: jspb.Message.getFieldWithDefault(msg, 17, 0),
    quotaUsed: jspb.Message.getFieldWithDefault(msg, 18, 0),
    quotaRemaining: jspb.Message.getFieldWithDefault(msg, 19, 0),
    unlimited: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    createTime: jspb.Message.getFieldWithDefault(msg, 21, ""),
    updateTime: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskInfo}
 */
proto.CategoryPredict.CategoryTaskInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskInfo;
  return proto.CategoryPredict.CategoryTaskInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskInfo}
 */
proto.CategoryPredict.CategoryTaskInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetColumn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumns(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTopCategoryCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxLevel(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRows(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProcessedRows(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuccessRows(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedRows(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProgress(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setProgressMessage(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTier(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuotaLimit(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuotaUsed(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuotaRemaining(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimited(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreateTime(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getTargetColumn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColumnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getTopCategoryCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMaxLevel();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getProcessedRows();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getSuccessRows();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getFailedRows();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getProgress();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getProgressMessage();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTier();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getQuotaLimit();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getQuotaUsed();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getQuotaRemaining();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getUnlimited();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getCreateTime();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getUpdateTime();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setTaskId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setFileName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 file_size = 3;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setFileSize = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string target_column = 4;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getTargetColumn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setTargetColumn = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string columns = 5;
 * @return {!Array<string>}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getColumnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setColumnsList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.addColumns = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.clearColumnsList = function() {
  this.setColumnsList([]);
};


/**
 * optional int32 top_category_count = 6;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getTopCategoryCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setTopCategoryCount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 max_level = 7;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getMaxLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setMaxLevel = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 total_rows = 9;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setTotalRows = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 processed_rows = 10;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getProcessedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setProcessedRows = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 success_rows = 11;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getSuccessRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setSuccessRows = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 failed_rows = 12;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getFailedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setFailedRows = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 progress = 13;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getProgress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setProgress = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string progress_message = 14;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getProgressMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setProgressMessage = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string error_message = 15;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setErrorMessage = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string tier = 16;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getTier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setTier = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 quota_limit = 17;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getQuotaLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setQuotaLimit = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 quota_used = 18;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getQuotaUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setQuotaUsed = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 quota_remaining = 19;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getQuotaRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setQuotaRemaining = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional bool unlimited = 20;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getUnlimited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setUnlimited = function(value) {
  jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional string create_time = 21;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getCreateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setCreateTime = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string update_time = 22;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskInfo.prototype.getUpdateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskInfo.prototype.setUpdateTime = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    task: (f = msg.getTask()) && proto.CategoryPredict.CategoryTaskInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskResponse}
 */
proto.CategoryPredict.CategoryTaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskResponse;
  return proto.CategoryPredict.CategoryTaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskResponse}
 */
proto.CategoryPredict.CategoryTaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.CategoryPredict.CategoryTaskInfo;
      reader.readMessage(value,proto.CategoryPredict.CategoryTaskInfo.deserializeBinaryFromReader);
      msg.setTask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.CategoryPredict.CategoryTaskInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool status = 1;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryTaskResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CategoryTaskInfo task = 3;
 * @return {?proto.CategoryPredict.CategoryTaskInfo}
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.getTask = function() {
  return /** @type{?proto.CategoryPredict.CategoryTaskInfo} */ (
    jspb.Message.getWrapperField(this, proto.CategoryPredict.CategoryTaskInfo, 3));
};


/** @param {?proto.CategoryPredict.CategoryTaskInfo|undefined} value */
proto.CategoryPredict.CategoryTaskResponse.prototype.setTask = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.clearTask = function() {
  this.setTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.CategoryPredict.CategoryTaskResponse.prototype.hasTask = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.CategoryPredict.CategoryTaskPageResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskPageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskPageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskPageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recordsList: jspb.Message.toObjectList(msg.getRecordsList(),
    proto.CategoryPredict.CategoryTaskInfo.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0),
    current: jspb.Message.getFieldWithDefault(msg, 5, 0),
    size: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskPageResponse}
 */
proto.CategoryPredict.CategoryTaskPageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskPageResponse;
  return proto.CategoryPredict.CategoryTaskPageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskPageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskPageResponse}
 */
proto.CategoryPredict.CategoryTaskPageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.CategoryPredict.CategoryTaskInfo;
      reader.readMessage(value,proto.CategoryPredict.CategoryTaskInfo.deserializeBinaryFromReader);
      msg.addRecords(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskPageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskPageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskPageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.CategoryPredict.CategoryTaskInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional bool status = 1;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CategoryTaskInfo records = 3;
 * @return {!Array<!proto.CategoryPredict.CategoryTaskInfo>}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.getRecordsList = function() {
  return /** @type{!Array<!proto.CategoryPredict.CategoryTaskInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.CategoryPredict.CategoryTaskInfo, 3));
};


/** @param {!Array<!proto.CategoryPredict.CategoryTaskInfo>} value */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.setRecordsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.CategoryPredict.CategoryTaskInfo}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.addRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.CategoryPredict.CategoryTaskInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.clearRecordsList = function() {
  this.setRecordsList([]);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 current = 5;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.setCurrent = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 size = 6;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskPageResponse.prototype.setSize = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskRowsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskRowsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRowsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    current: jspb.Message.getFieldWithDefault(msg, 2, 0),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskRowsRequest}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskRowsRequest;
  return proto.CategoryPredict.CategoryTaskRowsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskRowsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskRowsRequest}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskRowsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskRowsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRowsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.setTaskId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 current = 2;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.setCurrent = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 size = 3;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskRowsRequest.prototype.setSize = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    rowNo: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dataJson: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sourceText: jspb.Message.getFieldWithDefault(msg, 3, ""),
    category: jspb.Message.getFieldWithDefault(msg, 4, ""),
    firstL1: jspb.Message.getFieldWithDefault(msg, 5, ""),
    firstL2: jspb.Message.getFieldWithDefault(msg, 6, ""),
    firstL3: jspb.Message.getFieldWithDefault(msg, 7, ""),
    secondL1: jspb.Message.getFieldWithDefault(msg, 8, ""),
    secondL2: jspb.Message.getFieldWithDefault(msg, 9, ""),
    secondL3: jspb.Message.getFieldWithDefault(msg, 10, ""),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 12, ""),
    aiL1: jspb.Message.getFieldWithDefault(msg, 13, ""),
    aiL2: jspb.Message.getFieldWithDefault(msg, 14, ""),
    aiL3: jspb.Message.getFieldWithDefault(msg, 15, ""),
    finalL1: jspb.Message.getFieldWithDefault(msg, 16, ""),
    finalL2: jspb.Message.getFieldWithDefault(msg, 17, ""),
    finalL3: jspb.Message.getFieldWithDefault(msg, 18, ""),
    decisionSource: jspb.Message.getFieldWithDefault(msg, 19, ""),
    aiConfidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    aiModelVersion: jspb.Message.getFieldWithDefault(msg, 21, ""),
    taxonomyVersion: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskRow}
 */
proto.CategoryPredict.CategoryTaskRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskRow;
  return proto.CategoryPredict.CategoryTaskRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskRow}
 */
proto.CategoryPredict.CategoryTaskRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRowNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataJson(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceText(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstL1(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstL2(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstL3(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondL1(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondL2(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondL3(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiL1(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiL2(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiL3(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalL1(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalL2(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalL3(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDecisionSource(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAiConfidence(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiModelVersion(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxonomyVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowNo();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDataJson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSourceText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFirstL1();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFirstL2();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFirstL3();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSecondL1();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSecondL2();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecondL3();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAiL1();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getAiL2();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getAiL3();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getFinalL1();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getFinalL2();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getFinalL3();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getDecisionSource();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getAiConfidence();
  if (f !== 0.0) {
    writer.writeDouble(20, f);
  }
  f = message.getAiModelVersion();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getTaxonomyVersion();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
};


/**
 * optional int32 row_no = 1;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getRowNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setRowNo = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string data_json = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getDataJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setDataJson = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string source_text = 3;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getSourceText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setSourceText = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category = 4;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setCategory = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string first_l1 = 5;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getFirstL1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setFirstL1 = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string first_l2 = 6;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getFirstL2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setFirstL2 = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string first_l3 = 7;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getFirstL3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setFirstL3 = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string second_l1 = 8;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getSecondL1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setSecondL1 = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string second_l2 = 9;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getSecondL2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setSecondL2 = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string second_l3 = 10;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getSecondL3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setSecondL3 = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string status = 11;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string error_message = 12;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRow.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setErrorMessage = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getAiL1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setAiL1 = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getAiL2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setAiL2 = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getAiL3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setAiL3 = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getFinalL1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setFinalL1 = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getFinalL2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setFinalL2 = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getFinalL3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setFinalL3 = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getDecisionSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setDecisionSource = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};

/** @return {number} */
proto.CategoryPredict.CategoryTaskRow.prototype.getAiConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};

/** @param {number} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setAiConfidence = function(value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getAiModelVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setAiModelVersion = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};

/** @return {string} */
proto.CategoryPredict.CategoryTaskRow.prototype.getTaxonomyVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};

/** @param {string} value */
proto.CategoryPredict.CategoryTaskRow.prototype.setTaxonomyVersion = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.CategoryPredict.CategoryTaskRowsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryTaskRowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryTaskRowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recordsList: jspb.Message.toObjectList(msg.getRecordsList(),
    proto.CategoryPredict.CategoryTaskRow.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0),
    current: jspb.Message.getFieldWithDefault(msg, 5, 0),
    size: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryTaskRowsResponse}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryTaskRowsResponse;
  return proto.CategoryPredict.CategoryTaskRowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryTaskRowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryTaskRowsResponse}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.CategoryPredict.CategoryTaskRow;
      reader.readMessage(value,proto.CategoryPredict.CategoryTaskRow.deserializeBinaryFromReader);
      msg.addRecords(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryTaskRowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryTaskRowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryTaskRowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.CategoryPredict.CategoryTaskRow.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional bool status = 1;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CategoryTaskRow records = 3;
 * @return {!Array<!proto.CategoryPredict.CategoryTaskRow>}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.getRecordsList = function() {
  return /** @type{!Array<!proto.CategoryPredict.CategoryTaskRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.CategoryPredict.CategoryTaskRow, 3));
};


/** @param {!Array<!proto.CategoryPredict.CategoryTaskRow>} value */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.setRecordsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.CategoryPredict.CategoryTaskRow}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.addRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.CategoryPredict.CategoryTaskRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.clearRecordsList = function() {
  this.setRecordsList([]);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 current = 5;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.setCurrent = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 size = 6;
 * @return {number}
 */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.CategoryPredict.CategoryTaskRowsResponse.prototype.setSize = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryOperationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryOperationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryOperationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    task: (f = msg.getTask()) && proto.CategoryPredict.CategoryTaskInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryOperationResponse}
 */
proto.CategoryPredict.CategoryOperationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryOperationResponse;
  return proto.CategoryPredict.CategoryOperationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryOperationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryOperationResponse}
 */
proto.CategoryPredict.CategoryOperationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.CategoryPredict.CategoryTaskInfo;
      reader.readMessage(value,proto.CategoryPredict.CategoryTaskInfo.deserializeBinaryFromReader);
      msg.setTask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryOperationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryOperationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryOperationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.CategoryPredict.CategoryTaskInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool status = 1;
 * @return {boolean}
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.CategoryPredict.CategoryOperationResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryOperationResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CategoryTaskInfo task = 3;
 * @return {?proto.CategoryPredict.CategoryTaskInfo}
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.getTask = function() {
  return /** @type{?proto.CategoryPredict.CategoryTaskInfo} */ (
    jspb.Message.getWrapperField(this, proto.CategoryPredict.CategoryTaskInfo, 3));
};


/** @param {?proto.CategoryPredict.CategoryTaskInfo|undefined} value */
proto.CategoryPredict.CategoryOperationResponse.prototype.setTask = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.clearTask = function() {
  this.setTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.CategoryPredict.CategoryOperationResponse.prototype.hasTask = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.toObject = function(opt_includeInstance) {
  return proto.CategoryPredict.CategoryExportChunk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CategoryPredict.CategoryExportChunk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryExportChunk.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: msg.getData_asB64(),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CategoryPredict.CategoryExportChunk}
 */
proto.CategoryPredict.CategoryExportChunk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CategoryPredict.CategoryExportChunk;
  return proto.CategoryPredict.CategoryExportChunk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CategoryPredict.CategoryExportChunk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CategoryPredict.CategoryExportChunk}
 */
proto.CategoryPredict.CategoryExportChunk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CategoryPredict.CategoryExportChunk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CategoryPredict.CategoryExportChunk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CategoryPredict.CategoryExportChunk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/** @param {!(string|Uint8Array)} value */
proto.CategoryPredict.CategoryExportChunk.prototype.setData = function(value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryExportChunk.prototype.setFileName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.CategoryPredict.CategoryExportChunk.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.CategoryPredict.CategoryExportChunk.prototype.setContentType = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.CategoryPredict);
